export default __webpack_public_path__ + "static/media/badge.49cfe813.svg";